/* unplugin-vue-components disabled */import { render } from "./BusIndexView.vue?vue&type=template&id=6697e4f2&scoped=true"
import script from "./BusIndexView.vue?vue&type=script&lang=js"
export * from "./BusIndexView.vue?vue&type=script&lang=js"

import "./BusIndexView.vue?vue&type=style&index=0&id=6697e4f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6697e4f2"]])

export default __exports__